import React, { useState } from 'react';
import InputUi, { InputType } from '../../../ui/input.ui';
import FileUpload, { FileUploadType } from '../../../ui/file-upload.ui';
import { Verification } from '../../../user/user.type';

import styles from './onboarding-step-upload-documents.module.css';

type OnboardingStepUploadDocumentsUiProps = {
  linkedinLink?: string;
  cvDescription?: string;
  linkedinLinkError?: string;
  cvError?: string;
  cvDescriptionError?: string;
  isAppliedForPosition?: boolean;
  isSubmitting?: boolean;
  hasCvUploaded?: boolean;
  currentCvFileName?: string;
  onUpdateVerificationField: (field: keyof Verification, value: string) => void;
  onSetVerificationDocument: (fieldName: string, file: File) => void;
  onCvUploadError: (error: string | null) => void;
}

const OnboardingStepUploadDocumentsUi = (props: OnboardingStepUploadDocumentsUiProps) => {
  const {
    linkedinLink,
    cvDescription,
    linkedinLinkError,
    cvError,
    cvDescriptionError,
    isAppliedForPosition,
    isSubmitting = false,
    hasCvUploaded,
    currentCvFileName,
    onUpdateVerificationField,
    onSetVerificationDocument,
    onCvUploadError,
  } = props;

  const [fileUploadError, setFileUploadError] = useState<string | null>(null);
  const linkedInPrefix = 'https://www.linkedin.com/in/';

  const handleCvError = (error: string | null) => {
    setFileUploadError(error);
    onCvUploadError(error);
  };

  // Initialize with prefix if field is empty
  React.useEffect(() => {
    if (!linkedinLink) {
      onUpdateVerificationField('linkedInProfileUrl', linkedInPrefix);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {/* LinkedIn link */}
      <InputUi
        type={InputType.text}
        id="linkedinLink"
        value={linkedinLink || linkedInPrefix}
        labelText={'Share here your link to your LinkedIn profile'}
        onChange={(val) =>
          onUpdateVerificationField('linkedInProfileUrl', val)
        }
        disabled={isSubmitting}
        className={styles.cvUpload}
      />
      {linkedinLinkError && <div className={styles.error}>{linkedinLinkError}</div>}

      {/* CV Upload + Description */}
      <div className={styles.sectionTitle}>
        {isAppliedForPosition ? 'Please upload your CV' : 'Or upload your CV'}
      </div>
      <div className={styles.uploadWithDescription}>
        <FileUpload
          uploadType={FileUploadType.document}
          onFileChange={(file) => {
            if (file) {
              onSetVerificationDocument('verificationCV', file);
            }
          }}
          disabled={isSubmitting}
          hasFileUploaded={hasCvUploaded}
          fileName={currentCvFileName}
          onError={handleCvError}
        />
        <div className={styles.inputWrapper}>
          <InputUi
            type={InputType.text}
            id="cvDescription"
            value={cvDescription || ''}
            onChange={(val) =>
              onUpdateVerificationField('verificationCvDescription', val)
            }
            placeholder="Enter Description"
            maxLength={100}
            disabled={isSubmitting}
          />
        </div>
      </div>
      {cvError && <div className={styles.error}>{cvError}</div>}
      {fileUploadError && <div className={styles.error}>{fileUploadError}</div>}
      {cvDescriptionError && <div className={styles.error}>{cvDescriptionError}</div>}
    </>
  );
};

export default OnboardingStepUploadDocumentsUi;
